<template>
  <div class="fg-notification-box">
    <div class="fg-wrap">
      <div class="fg-title">
        <div class="txt">赴馆通知书</div>
        <a class="small" @click="interviewChangeDialog = true;updateDateType = 1" v-if="changeShouldShow && !order.enable_api && !cusAllChange">修改赴馆日期</a>
        <el-button type="default show-interview-video-btn" v-if="showOpenInterviewVideo" @click="showVideo = true;">
          <img src="../../assets/imgs/play.png"> 面试培训视频</el-button>
      </div>

      <div class="fg-items">
        <div class="fg-item nameAndTime" v-for="item in applicantGrouped" :key="item.order_applicant_id">
          <router-link class="fg-check" :to="{name:'interview', params:{ oid: order.user_order_id, aid: item.order_applicant_id, displayName:item.displayName}}" v-if="[0, 2].indexOf(+item.interview_status) > -1">查看赴馆通知书
          </router-link>
          <div class="fg-item-title">
            <div class="fg-item-title-icon"></div>
            <div class="fg-item-title-detail">{{item.displayName}}</div>
          </div>
          <div class="fg-item-content" v-if="item.interview_status==0">
            <p>赴馆日期：指定日期 {{item.displayTime + '（请提前15分钟抵达）'}}</p>
          </div>
          <div class="fg-item-content" v-if="item.interview_status==1">
            <p>已申请修改赴馆时间</p>
            <p v-if="item.embassy_district_name">赴馆城市：{{item.embassy_district_name}}</p>
            <p>{{item.date_choice == 0 ? "赴馆日期：指定日期 " + item.preferred_date_str : item.date_choice == 2 ? "近30天内均无法前往：" + item.other_date : choiceMap[item.date_choice] }}</p>
          </div>
          <div class="fg-item-content" v-if="item.interview_status==2">
            <p>申请修改赴馆时间【待审核】</p>
            <p v-if="item.embassy_district_name">赴馆城市：{{item.embassy_district_name}}</p>
            <p>{{item.date_choice == 0 ? "赴馆日期：指定日期 " + item.preferred_date_str : item.date_choice == 2 ? "近30天内均无法前往：" + item.other_date : choiceMap[item.date_choice] }}</p>
          </div>
        </div>

        <div class="fg-item address" v-show="showEmbassy">
          <div class="fg-item-title">
            <div class="fg-item-title-icon"></div>
            <div class="fg-item-title-detail">
              {{applicantGrouped[0].embassy_name}}
            </div>
          </div>
          <div class="fg-item-content">{{applicantGrouped[0].address}}</div>
        </div>

      </div>
    </div>

    <el-dialog title="选择需要修改的申请人" size="tiny" v-model="interviewChangeDialog">
      <div class="cue">
        <img src="../../assets/imgs/admin-order/notice.png" alt="">
        <div class="cue-item">使馆预约流程较为复杂，每次修改赴馆时间需补缴<span>每人每次{{price}}元</span>服务费</div>
        <div class="cue-item" v-if="earlistDateData && earlistDateData.interview_notice">{{earlistDateData.interview_notice}}</div>
      </div>
      <div class="checkboxs">
        <el-checkbox-group v-model="applicantIdsToChange">
          <el-checkbox :label="applicant.order_applicant_id" v-for="applicant in applicantChangable" :key="applicant.order_applicant_id">
            {{applicant.applicant_name}}
          </el-checkbox>
        </el-checkbox-group>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="interviewChangeDialog = false" class="footer-btn">取 消</el-button>
        <el-button type="primary" @click="applicantSeletOK" class="footer-btn" :disabled="!applicantIdsToChange.length">确定</el-button>
      </span>
    </el-dialog>

    <interview-video v-if="showVideo" @close="showVideo = false;" @share="wxShare"></interview-video>
    <wx-share :show="showShare" :order="order" :names="allApplicantNames" :url="shareUrl" @close="showShare = false"></wx-share>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import dateUtils from '../../libs/date-util';
import addressUtils from '../../libs/address-utils';
import pcdService from '../../services/pcd-service';
import applicantConstants from '../../constants/applicant-constants';
import interviewVideo from './interview-video';
import wxShare from '../../components/order-detail/wx-share';
import wxUtils from '../../libs/wx-utils';

const makePreferredDateKey = preferred_date =>
  preferred_date.map(({ date, period }) => `${date}#${period}`).join('+');

const periodMap = {
  0: '整天',
  1: '上午',
  2: '下午',
};

const choiceMap = {
  1: '近30天内任何时间都方便',
  2: '近30天内均无法前往',
  3: '预计出行日期之前均方便',
  4: '30天后均方便',
};

export default {
  props: ['order', 'price', 'earlistDateData'],
  components: {
    interviewVideo,
    wxShare,
  },
  data() {
    return {
      choiceMap,
      idate: '',
      address: '',
      interviewChangeDialog: false,
      applicantGrouped: [[]],
      showEmbassy: false,
      applicantIdsToChange: [],
      applicantChangable: [],
      showVideo: false,
      showShare: false,
      shareUrl: '',
      updateDateType: 1, // 修改赴馆时间类型：1为修改赴馆时间，2为重新预约缴费
    };
  },
  computed: {
    changeShouldShow() {
      return (
        this.applicantGrouped.some(val => +val.interview_status === 0) &&
        this.applicantChangable.length > 0
      );
    },

    // 是否所有使用户都申请了修改赴馆时间
    cusAllChange() {
      return this.applicantGrouped.every(item => +item.interview_status === 2);
    },

    allApplicantNames() {
      return this.order.applicant
        .map(applicant => applicant.applicant_name)
        .join('、');
    },

    // 显示面试通知书弹窗
    showOpenInterviewVideo() {
      return (
        this.order.need_interview > 0 &&
        this.order.applicant.some(
          applicant =>
            [
              applicantConstants.STATUS.embassyVerifing_4,
              applicantConstants.STATUS.waittingToTraining_12,
              applicantConstants.STATUS.waittingToGoToEmbassy_13,
            ].indexOf(applicant.applicant_status) > -1,
        )
      );
    },
  },
  watch: {
    order: {
      handler() {
        this.applicantChangable = this.order.applicant.filter(
          ({ applicant_status, interview_status }) =>
            [11, 12, 13, 18].indexOf(applicant_status) > -1 &&
            interview_status === 0,
        );

        this.applicantIdsToChange = this.applicantChangable.map(
          applicant => applicant.order_applicant_id,
        );

        const applicant = this.order.applicant;
        const applicantGroupedMap = {};

        const need_delivery = this.order.need_delivery;
        const need_interview = this.order.need_interview;

        // 将赴馆条件相同的申请人信息放在一起
        applicant.forEach((applicantVal) => {
          let shouldShowStatusList = [];
          if (!need_interview) {
            shouldShowStatusList = [4, 11, 12, 13, 18];
          }

          if (!need_delivery) {
            shouldShowStatusList = [11, 12, 13, 18];
          }
          if (
            shouldShowStatusList.indexOf(applicantVal.applicant_status) > -1 ||
            applicantVal.interview_status === 1
          ) {
            const interviewObj = applicantVal.interview;
            let key = '';
            if (applicantVal.interview_status === 0) {
              if (interviewObj.embassy_address) {
                // 预约成功的时候
                key = `${interviewObj.interview_time},${
                  interviewObj.embassy_address.embassy_name
                },${applicantVal.interview_status},${
                  interviewObj.companion_name
                },${interviewObj.companion_telephone}`;
              }
            } else {
              // 重新预约的时候
              key = `${interviewObj.date_choice},${
                applicantVal.interview_status
              },${
                interviewObj.embassy_district_name
              },${makePreferredDateKey(interviewObj.preferred_date)},${
                interviewObj.other_date
              }`;
            }
            // key不为空的话
            if (key) {
              applicantGroupedMap[key] = (
                applicantGroupedMap[key] || []
              ).concat(applicantVal)
              ;
            }
          }
        });

        // 获取pcds 和 地址 后再 转换成我们想要的格式
        pcdService.getPcd().then((pcdData) => {
          const pcds = pcdData;

          this.applicantGrouped = Object.keys(applicantGroupedMap).map(
            (joinKey) => {
              // 申请人id
              const order_applicant_id =
                applicantGroupedMap[joinKey][0].order_applicant_id;
              // 处理名字
              const applicantList = applicantGroupedMap[joinKey];
              let displayName = '';
              if (applicantList.length === 1) {
                displayName = applicantList[0].applicant_name;
              } else if (applicantList.length > 1) {
                applicantList.forEach((val) => {
                  displayName += `${val.applicant_name}、`;
                });
                displayName = displayName.slice(0, -1);
              }
              // 处理地址
              const embassy_address =
                applicantGroupedMap[joinKey][0].interview.embassy_address;
              let address;
              if (embassy_address) {
                address = addressUtils.getAddress(pcds, {
                  province_code: embassy_address.province_code,
                  city_code: embassy_address.city_code,
                  county_code: embassy_address.county_code,
                  detail_address: embassy_address.detail_address,
                });
              }

              const embassy_district_name = applicantGroupedMap[joinKey][0].interview.embassy_district_name;

              // 判断是否修改过赴馆时间
              if (applicantGroupedMap[joinKey][0].interview_status === 0) {
                const [
                  interview_time,
                  embassy_name,
                  interview_status,
                ] = joinKey.split(',');
                const displayTime = `${dateUtils.dateChange(interview_time)} (GMT+8)`;

                return {
                  displayName,
                  embassy_name,
                  displayTime,
                  interview_status,
                  address,
                  order_applicant_id,
                  embassy_district_name,
                };
              }
              const [date_choice, interview_status] = joinKey.split(',');
              let preferred_date_str;
              if (+date_choice === 0) {
                // 手动选择修改
                const { preferred_date } = applicantGroupedMap[
                  joinKey
                ][0].interview; // 手动选择的希望赴馆的日期(数组)
                const preferred_date_change = preferred_date.map(
                  ({ date, period }) =>
                    `${dateUtils.formatDateWithzeroWithWeek(date)} ${
                      periodMap[period]
                    }`,
                );
                preferred_date_str = preferred_date_change.join('、');
              }

              const other_date =
                applicantGroupedMap[joinKey][0].interview.other_date;

              return {
                displayName,
                interview_status,
                date_choice,
                other_date,
                preferred_date_str,
                address,
                order_applicant_id,
                embassy_district_name,
              };
            },
          );


          // 大使馆地址一致且没有人修改过
          this.showEmbassy = this.applicantGrouped.every(
            val =>
              val.embassy_name === this.applicantGrouped[0].embassy_name &&
              val.interview_status === 0,
          );
        }).catch((e) => {
          if (e) console.log(e);
        });
      },
      immediate: true,
    },
  },
  created() {
    // 处理数据
  },
  methods: {
    ...mapMutations('order/', ['APPLICANT_IDS_TO_CHANGE_SET']),

    wxShare() {
      if (!this.shareUrl) {
        wxUtils
          .getQRCode(
            this.order.user_order_id,
            this.order.applicant[0].order_applicant_id,
          )
          .then((data) => {
            this.shareUrl = data;
            this.showShare = true;
          }).catch((e) => {
            if (e) console.log(e);
          });
      } else {
        this.showShare = true;
      }
    },

    // 选择要改赴馆时间的申请人完毕
    applicantSeletOK() {
      this.APPLICANT_IDS_TO_CHANGE_SET({
        applicantIds: this.applicantIdsToChange,
      });

      this.$router.push({
        name: 'interviewChange',
        params: { oid: this.order.user_order_id },
        // 传递申请人数组（先转化为string）
        query: {
          aidArray: JSON.stringify(this.applicantIdsToChange),
          updateDateType: this.updateDateType,
        },
      });
      this.interviewChangeDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/base.less';

.fg-notification-box {
  width: 920px;
  margin-bottom: 15px;
  color: #444;

  .fg-wrap {
    background-color: #fff;
    .fg-title {
      padding: 0 40px 0 20px;
      height: 50px;
      display: flex;
      align-items: center;
      background-color: #fbfbfb;
      .txt {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        flex: 1;
      }
      .small {
        font-size: 14px;
        color: @main;
        margin-left: 8px;
        display: inline-block;
      }
    }

    .fg-items {
      padding: 0 40px 0 68px;
    }

    .fg-item {
      position: relative;
      padding: 20px 0 20px 0px;
      font-size: 16px;
      border-bottom: 1px solid #f4f4f4;
      .fg-item-title {
        display: flex;
        flex: 1;
        align-items: center;
        .fg-item-title-icon {
          width: 16px;
          height: 16px;
          margin-left: -26px;
          margin-right: 10px;
          background-size: 16px 16px !important;
          flex: none;
        }
        .fg-item-title-detail {
          color: #333;
        }
      }
      .fg-item-content {
        margin-top: 12px;
        font-size: 14px;
        color: #777;
        p{
          margin-top: 10px;
        }
      }
    }

    .fg-check {
      display: block;
      float: right;
      width: 134px;
      height: 34px;
      line-height: 33px;
      border: 1px solid #5e9be1;
      border-radius: 4px;
      text-align: center;
      color: #5e9be1;
      right: -5px;
      top: 30px;
      font-size: 14px;
      margin-top: 5px;
    }

    .nameAndTime {
      .fg-item-title-icon {
        background: url(../../assets/imgs/fg_date_white.png);
      }
      .fg-item-content {
        color: #ff5a60;
      }
    }
    .address {
      .fg-item-title-icon {
        background: url(../../assets/imgs/fg_address.png);
      }
    }
  }
}

.cue {
  background: #ffffc5;
  font-size: 14px;
  color: #ff5a60;
  padding: 12px 0 12px 45px;
  position: relative;
  line-height: 1;
  span{
    font-weight: bold;
  }
  img {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 20px;
    top: 10px;
  }
  .cue-item{
    & + .cue-item{
      margin-top: 8px;
    }
  }
}

.checkboxs {
  padding: 30px;
  &::after{
    content: '';
    clear: both;
    width: 100%;
    display: block;
  }
  .el-checkbox-group {
    // margin-left: -22px;
    margin-top: -10px;
  }

  .el-checkbox {
    // margin-left: 22px;
    margin-left: 0;
    width: 33%;
    margin-top: 10px;
    float: left;
  }
}
</style>

<style lang="less">
@import '../../assets/less/base.less';
.fg-notification-box{
.el-dialog {
  width: 570px;
}
.el-dialog__title{
  font-size: 18px;
  font-weight: 400;
}
.el-dialog__body {
  padding: 10px 0 0 0;
}
}
.footer-btn{
  width: 140px;
  height: 40px;
  font-size: 16px;
}

.show-interview-video-btn {
  margin-left: 40px;
  color: @main;
  border-color: @main;
  width: 134px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0;
  &:hover {
    opacity: 0.8;
  }
  span {
    display: flex;
    align-items: center;
    img {
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-fg-notification.vue